<template>
  <div>
    <titulo-modulo titulo="Empréstimos" />
    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <template v-else-if="emprestimo && emprestimo.valorapagar > 0">
      <v-card flat class="mt-3 pb-2">
        <v-card-title class="font-weight-bold subtitle-1"
          >Valor Restante a Pagar</v-card-title
        >
        <v-card-subtitle class="headline font-weight-bold green--text">{{
          formatarMoeda(emprestimo.valorapagar)
        }}</v-card-subtitle>
      </v-card>
      <v-card flat class="mt-2">
        <v-card-title class="font-weight-bold subtitle-1"
          >Parcelas Restantes</v-card-title
        >
        <v-card-subtitle class="ml-2 headline font-weight-bold green--text">
          {{ emprestimo.parcelas.length }}
        </v-card-subtitle>
        <v-card-text>
          <v-data-table
            :items="emprestimo.parcelas"
            :headers="headers"
            no-data-text="Nenhuma parcela encontrada"
          >
            <template v-slot:[`item.vcto`]="{ item }">
              {{ formatarData(item.vcto) }}
            </template>
            <template v-slot:[`item.valor`]="{ item }">
              {{ formatarMoeda(item.valor) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </template>
    <v-alert v-else type="info" text class="mt-3"
      >Nenhum empréstimo encontrado</v-alert
    >
  </div>
</template>

<script>
import axios from "axios";
import TituloModulo from "../../components/TituloModulo.vue";
import { formatMoeda, dateFormat } from "@/global";

export default {
  components: {
    TituloModulo,
  },
  data: () => ({
    carregando: true,
    emprestimo: null,
    headers: [
      {
        text: "Vencimento",
        value: "vcto",
      },
      {
        text: "Valor",
        value: "valor",
      },
    ],
  }),
  methods: {
    formatarData(value) {
      return dateFormat(value);
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
  },
  async mounted() {
    this.carregando = true;
    await axios
      .get("/colaborador/financeiro?funcao=EMPRESTIMOS")
      .then((res) => {
        if (res.data.success) {
          this.emprestimo = res.data.data;
        } else this.$toasted.error(res.data.msg);
      })
      .catch((e) => this.$toasted.error(e));
    this.carregando = false;
  },
};
</script>

<style>
</style>